import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RegisterPrompt = () => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <div className="w-full max-w-md mx-auto mt-8">
      <div className="bg-muted/50 border border-border rounded-lg p-6 text-center">
        <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="UserPlus" size={24} className="text-secondary" />
        </div>
        
        <h3 className="text-lg font-semibold text-foreground mb-2">New to Share Good?</h3>
        <p className="text-sm text-muted-foreground mb-6">
          Join our community of generous donors and start making a difference today. 
          Create your account to discover causes, track your impact, and connect with like-minded givers.
        </p>
        
        <Button
          variant="secondary"
          fullWidth
          onClick={handleRegisterClick}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Create Account
        </Button>
        
        <div className="mt-4 flex items-center justify-center space-x-6 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Shield" size={14} />
            <span>Secure</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Zap" size={14} />
            <span>Fast Setup</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Users" size={14} />
            <span>Join 10k+ Donors</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPrompt;